/**
 * @file style
 * @author Yu Zong(liuxuanzy@qq.com)
 */
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { tuple } from '@tencent/glue-util-types';
export var BOUNDARY_HEIGHT_PROPS = tuple('height', 'minHeight', 'maxHeight');
export var PARENT_HEIGHT_PROPS = tuple.apply(void 0, __spreadArray(__spreadArray([], BOUNDARY_HEIGHT_PROPS, false), ['top',
    'bottom'], false));
export var BOUNDARY_WIDTH_PROPS = tuple('width', 'minWidth', 'maxWidth', 'margin', 'marginTop', 'marginBottom', 'marginLeft', 'marginRight', 'padding', 'paddingTop', 'paddingBottom', 'paddingLeft', 'paddingRight');
export var PARENT_WIDTH_PROPS = tuple.apply(void 0, __spreadArray(__spreadArray([], BOUNDARY_WIDTH_PROPS, false), ['left',
    'right'], false));
export var TRANSFORM_FIXED_PROPS = tuple('translateX', 'translateY');
export var ELEMENT_SIZE_PROPS = tuple.apply(void 0, __spreadArray(__spreadArray([], TRANSFORM_FIXED_PROPS, false), ['backgroundPositionX',
    'backgroundPositionY',
    'borderRadius',
    'borderTopLeftRadius',
    'borderTopRightRadius',
    'borderBottomLeftRadius',
    'borderBottomRightRadius'], false));
export var PERCENT_SIZE_PROPS = tuple.apply(void 0, __spreadArray(__spreadArray(__spreadArray(__spreadArray([], PARENT_HEIGHT_PROPS, false), PARENT_WIDTH_PROPS, false), ELEMENT_SIZE_PROPS, false), ['flexBasis'], false));
export var BOUNDARY_FIX_PROPS = tuple('borderWidth', 'borderTopWidth', 'borderRightWidth', 'borderBottomWidth', 'borderLeftWidth');
export var FIXED_SIZE_PROPS = tuple.apply(void 0, __spreadArray(__spreadArray(__spreadArray([], PERCENT_SIZE_PROPS, false), BOUNDARY_FIX_PROPS, false), ['fontSize',
    'letterSpacing',
    'lineHeight',
    'boxShadowOffsetX',
    'boxShadowOffsetY',
    'boxShadowRadius',
    'boxShadowSpread'], false));
export var BOUNDARY_PROPS = tuple.apply(void 0, __spreadArray(__spreadArray(__spreadArray([], BOUNDARY_HEIGHT_PROPS, false), BOUNDARY_WIDTH_PROPS, false), BOUNDARY_FIX_PROPS, false));
export var ROTATE_PROPS = tuple('rotate', 'rotateX', 'rotateY', 'rotateZ');
export var TRANSFORM_NUM_PROPS = tuple.apply(void 0, __spreadArray(__spreadArray([], ROTATE_PROPS, false), ['perspective',
    'scale',
    'scaleX',
    'scaleY',
    'skewX',
    'skewY'], false));
export var TRANSFORM_PROPS = tuple.apply(void 0, __spreadArray(__spreadArray([], TRANSFORM_FIXED_PROPS, false), TRANSFORM_NUM_PROPS, false));
export var NORMAL_NUMBER_PROPS = tuple('zIndex', 'opacity', 'flex', 'flexGrow', 'flexShrink');
export var ANIMATION_PROPS = tuple.apply(void 0, __spreadArray(__spreadArray(__spreadArray(__spreadArray([], FIXED_SIZE_PROPS, false), TRANSFORM_NUM_PROPS, false), NORMAL_NUMBER_PROPS, false), ['backgroundColor',
    'color'], false));
